import React from "react";
import Layout from "../components/App/Layout";
import Navbar from "../components/App/Navbar";
import Legals from "../components/App/Legals";
import HeaderBanner from "../components/Privacy/HeaderBanner";
import Footer from "../components/App/Footer";


const TermsOfService = () => {
  return (
    <Layout>
      <Navbar />
      <HeaderBanner />
      <section className="terms-of-service-area ptb-100">
        <div class="content-wrap dark-two">
          <div class="container clearfix">
            <div id="faqs" class="faqs">
              <h4>General Information</h4>
              <p>
                This online Privacy Policy describes the ways in which we
                collect information from you when you use this website, and what
                we may use it for. If you have any questions or need further
                information about our privacy practices, please contact us at
                privacy@tell.money or 57C Telfords Yard, 6-8 The Highway,
                Wapping, London, E1W 2BS, United Kingdom Tell Money Limiteds
                commitment to your privacy. We are committed to protecting your
                privacy. .
              </p>
              <p>
                Tell Money Limiteds commitment to your privacy. We are committed
                to protecting your privacy.
              </p>
              <h4>1. WHAT INFORMATION DO WE COLLECT?</h4>
              <p>We may collect data from you (User Data) in various ways: </p>
              <p>
                During the course of your use of this website (including,
                without limitation, all material you send or upload to this
                website or to an e-mail address given on this website (Your
                Material); and when we request further information from you from
                time to time following on from any contact you have made with us
                through this website.
              </p>
              <p>
                Some of it will inevitably comprise personal data about you.
                This Privacy Policy describes how we fulfil our obligations
                under applicable data protection laws.
              </p>
              <p>
                Log and Usage Data. Log and usage data is service-related,
                diagnostic, usage and performance information our servers
                automatically collect when you access or use our Website and
                which we record in log files. Depending on how you interact with
                us, this log data may include your IP address, device
                information, browser type and settings and information about
                your activity in the Website (such as the date/time stamps
                associated with your usage, pages and files viewed, searches and
                other actions you take such as which features you use), device
                event information (such as system activity, error reports
                (sometimes called 'crash dumps') and hardware settings).
              </p>
              <h4>2. USE OF COOKIES</h4>
              <p>
                A cookie is a tiny element of data that a website can send to
                your computer’s browser so that this computer will be recognised
                by the site on your return. Cookies allow our web server to
                recognise your computer on connection to our website, which in
                turn allows the server to make downloading of pages faster than
                on first viewing. In addition, cookies may also be used by us to
                establish statistics about the use of this website by Internet
                users by gathering and analysing data such as: most visited
                pages, time spent by users on each page, site performance, etc.
                By collecting and using such data, we hope to improve the
                quality of the site.
              </p>
              <p>
                The data collected by our servers and/or through cookies that
                may be placed on your computer will not be kept for longer than
                is necessary to fulfil the purposes mentioned above. In any
                event, such information may not be kept for longer than one
                year.
              </p>
              <p>
                Navigation data about site viewers is automatically collected by
                our servers. If you do not wish to have this navigation data
                collected, we recommend that you do not use this website. You
                can also set your browser to block the recording of cookies on
                your hard drive to minimise the amount of data that may be
                collected about your navigating on this site. The browser on
                your computer can be set to notify you when a cookie is being
                recorded on your computer’s hard drive. Most browsers can also
                be set to keep cookies from being recorded on your computer.
                However, for optimal use of this website, we recommend that you
                do not block the recording of cookies on your computer.
              </p>{" "}
              <p>
                All Tell Money Limited’s servers and computer systems are
                protected from outside intrusions. As a result, all data that
                may be collected about site viewers through the use of cookies
                will be protected from unauthorised access.
              </p>{" "}
              <p>
                Cookies used on this site are only active for the duration of
                your visit. Cookies used on this site are not stored on your
                computer once you have closed your web browser. Information
                generated by the use of cookies may be compiled into an
                aggregate form so that no individual can be identified.
              </p>
              <p>
                For more information about cookies, please see the Information
                Commissioner’s website home page or the Interactive Advertising
                Bureau.
              </p>
              <p>
                You may choose to not receive a cookie file by enabling your web
                browser to refuse cookies. The procedure for refusal of cookies
                may vary for different software products. Please check with your
                internet browser software help or your software supplier if you
                wish to refuse cookies.
              </p>
              <h4>3. PRIVACY OF ELECTRONIC COMMUNICATIONS</h4>
              <p>
                Although we welcome your queries, please note that any
                electronic communication through this website between you and us
                (or any of our employees or agents) may not be secure. For this
                reason, please do not send us any email that contains
                confidential or sensitive information.
              </p>
              <h4>4. DO WE USE COOKIES AND OTHER TRACKING TECHNOLOGIES?</h4>
              <p>
                In Short: We may use cookies and other tracking technologies to
                collect and store your information.
              </p>
              <p>
                We may use cookies and similar tracking technologies (like web
                beacons and pixels) to access or store information. Specific
                information about how we use such technologies and how you can
                refuse certain cookies is set out in our Cookie Notice.
              </p>
              <h4>5. OUR USE OF USER DATA</h4>
              <p>
                We will use User Data we collect from you only for the following
                purposes:
              </p>
              <p>
                1. To provide this website to you. <br/>2. We will use User Data to
                provide and improve this website to enable us to deal with any
                queries you have about this website and to notify you of any
                changes to this website. <br/>3. To include User Data in anonymous
                statistics. <br/>4. We may provide anonymous statistics about our
                users and related usage information to reputable third parties,
                but these statistics will not enable any third party to identify
                individuals or individual businesses. <br/>5. To provide you with
                information you have requested. <br/>6. We will use User Data to
                provide you with information and brochures you have requested
                through this website. <br/>7. Marketing Activities <br/>8. If you have
                already registered to receive marketing materials from us in
                paper and/or electronic form, we may use your data in order to
                send you in electronic and/or paper form marketing and other
                materials relating to Tell Money Limited, its products and/or
                services. We may use the data provided by you to update records
                held by Tell Money Limited. <br/>9. If you are not already registered
                to receive marketing information from us in paper and/or
                electronic form and wish to receive such information please
                click e-mail us.You may withdraw your consent to the receipt of
                marketing materials at any time and free of charge by sending an
                e-mail to us at privacy@tell.money. <br/>10. If Tell Money Limited
                re-organises or transfers its business, ceases to trade or goes
                insolvent. <br/>11. Tell Money Limited may at some stage re-organise
                or transfer all or part of its business. This may result in the
                transfer of your data to new entities (which will be
                subsidiaries or affiliates of Tell Money Limited) or third
                parties through which the whole or part of the business of Tell
                Money Limited will be carried out. <br/>12. If Tell Money Limited
                ceases to trade, or becomes insolvent, enters into receivership
                or any similar or equivalent event occurs, those acting on
                behalf of Tell Money Limited may sell the business or parts of
                it to a third party, in fulfilment of legal or business
                requirements. This may result in the transfer of your data to a
                third party through which the business or parts of it will be
                carried out. <br/>13. In circumstances where the business of Tell
                Money Limited or parts of it are transferred to a third party as
                described above, we shall use reasonable endeavours to contact
                you in advance of us disclosing your data to that third party,
                but you acknowledge that this might not be technically or
                commercially feasible in all the circumstances.
              </p>
              <h4>6. CONSENT</h4>
              <p>
                By continuing to use this website and by providing any personal
                data (including sensitive personal data) to us via this website
                or e-mail addresses provided on this website, you are consenting
                to our use of your personal data as set out in this Privacy
                Policy. Please do not send us any personal data if you do not
                want that information to be used by us in this manner.
              </p>
              <h4>7. TRANSFER OF USER DATA OUTSIDE OF THE USER JURISDICTION</h4>
              <p>
                The Internet is a global environment. In order to provide this
                website we may need to transfer User Data to locations outside
                the jurisdiction in which you are viewing this website (the User
                Jurisdiction) and process User Data outside the User
                Jurisdiction. If the User Jurisdiction is within the European
                Economic Area (the EEA) please note that such transfers and
                processing of User Data may be in locations outside the EEA. Any
                data sent or uploaded by you may be accessible in jurisdictions
                outside the User Jurisdiction (including outside the EEA). The
                level of data protection offered in such jurisdictions may be
                less than that offered within the User Jurisdiction or (as the
                case may be) within the EEA. User Data may be controlled and
                processed by any of Tell Money Limited’soffices, some of which
                may be outside the EEA. The location of our offices may change
                from time to time and Tell Money Limited may acquire offices in
                any number of countries or territories at any time, any one or
                more of which may act as controllers of and/or process User
                Data.
              </p>
              <p>
                By continuing to use this website and by providing any personal
                data (including sensitive personal data) to us via this website
                or e-mail addresses provided on this website, you are consenting
                to such transfers, provided that they are in accordance with the
                purposes set out above and elsewhere in the Legal Notices.
                Please do not send us any personal data if you do not consent to
                the transfer of this information to locations outside the User
                Jurisdiction (including, if applicable, outside the EEA).
              </p>
              <h4>8. LEGAL REQUIRMENTS</h4>
              <p>
                While it is unlikely, we may be required to disclose your User
                Data by a court order or to comply with other legal or
                regulatory requirements. We will use reasonable endeavours to
                notify you before we do so, unless we are legally restricted
                from doing so.
              </p>
              <h4>9. ACCESS TO AND CORRECTION OF USER DATA</h4>
              <p>
                You are entitled to a copy of your User Data and to have them
                rectified or deleted as required by applicable data protection
                legislation. For more information please send an email to
                privacy@tell.money.
              </p>
              <h4>10. GENERAL DATA PROTECTION REGULATION</h4>
              <p>
                Your rights under the General Data Protection Regulation (GDPR)
              </p>
              <p>
                • The right to be informed <br/>• The right of access <br/>• The right of
                rectification <br/>• The right of erasure <br/>• The right to restrict
                processing <br/>• The right to data portability <br/>• The right to object
                <br/>• Rights in relation to automated decision making and profiling
              </p>
              <p>
                If you would like further information about data protection you
                can visit the Information Commissioner’s Office (ICO) at
                ico.org.uk. The ICO is the UK’s independent authority set up to
                uphold information rights in the public interest and data
                privacy for individuals. We comply with all ICO regulatory and
                statutory requirements. You have the right to make a complaint
                to the ICO regarding the handling of your data.
              </p>
              <p>
                Changes to the Policy This Privacy Policy and/or the other Legal
                Notices may be amended by us at any time. Please check this
                website periodically to inform yourself of any changes.
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <Legals />
    </Layout>
  );
};

export default TermsOfService;
